import { useUser } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { fetchActivityReportById } from '@data';

export const getActivityReportKey = (activityId: number) => ['activity', 'report', activityId] as const;

export const useActivityReport = (activityId = -1) => {
    const { data: user } = useUser();
    const userId = user?.id ?? '';

    return useQuery({
        queryKey: getActivityReportKey(activityId),
        queryFn: () => fetchActivityReportById(activityId),
        enabled: activityId > 0 && !!userId,
        // Prevents booth cache clear
        refetchOnMount: false,
    });
};
